// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, updateNotificationSettingProfessional } from "../../Utils/Constants";
import { toast } from "react-toastify";


export const hitUpdateNotificationSettingProfessionalApi = createAsyncThunk("hitUpdateNotificationSettingProfessionalApi", async (payload) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("professionalToken")}`,
      },
    };
    const url = ApiBaseUrl + updateNotificationSettingProfessional;
    const response = await axios.put(url, payload, config);
    return response.data;
  } catch (error) {
    toast.error(error.response.data.message);
    throw error.response.data;
  }
});

const UpdateNotificationSettingProfessionalSlice = createSlice({
  name: "updateNotificationSettingProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitUpdateNotificationSettingProfessionalData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitUpdateNotificationSettingProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitUpdateNotificationSettingProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitUpdateNotificationSettingProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitUpdateNotificationSettingProfessionalData } = UpdateNotificationSettingProfessionalSlice.actions;
export default UpdateNotificationSettingProfessionalSlice.reducer;
